var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Cargo Market Vehicle Request Approval Flow")])])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Facility Name "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.branchNameList,
      "clearable": false,
      "name": "branchName",
      "placeholder": "Select Facility Name",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true
    },
    on: {
      "select": _vm.selectBranchName
    },
    model: {
      value: (_vm.branchName),
      callback: function($$v) {
        _vm.branchName = $$v
      },
      expression: "branchName"
    }
  })], 1)], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Approval Levels "), _c('span', {
    staticClass: "required"
  }, [_vm._v("* ")]), _vm._v("(From level 1 approval to final approval\n\t\t\t\t\t\tauthority)")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center ",
    attrs: {
      "width": "5%"
    }
  }, [_c('b', [_vm._v("Approval Level Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%",
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Approval Cost Limit")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "35%"
    }
  }, [_c('b', [_vm._v("User ID (Multi Selection)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center ",
    attrs: {
      "width": "6%"
    }
  }, [_c('b', [_vm._v("#")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.approvelData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.mincostlimit),
        expression: "data.mincostlimit"
      }],
      staticClass: "costlimit",
      attrs: {
        "type": "text",
        "min": 1,
        "placeholder": "Min Cost Limit",
        "id": 'mincostlimit' + index,
        "name": 'mincostlimit' + index,
        "title": "Min Limit"
      },
      domProps: {
        "value": (data.mincostlimit)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.mincostlimit = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-danger "
    }, [_vm._v(_vm._s(data.mincostlimitError))])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.maxcostlimit),
        expression: "data.maxcostlimit"
      }],
      staticClass: "costlimit",
      attrs: {
        "type": "text",
        "min": 1,
        "placeholder": "Max Cost Limit",
        "name": 'maxcostlimit' + index,
        "id": 'maxcostlimit' + index,
        "title": "Max Limit"
      },
      domProps: {
        "value": (data.maxcostlimit)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.maxcostlimit = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-danger "
    }, [_vm._v(_vm._s(data.maxcostlimitError))])], 1), _vm._v(" "), _c('td', [_c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-user'></i>"
      }
    }, [_c('multiselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "options": _vm.userList,
        "track-by": "id",
        "label": "label",
        "multiple": true,
        "placeholder": "Select User",
        "name": "user"
      },
      on: {
        "input": function($event) {
          _vm.removeUserError(data.userId, index)
        },
        "select": _vm.onUserSelect,
        "remove": _vm.onUserRemove
      },
      model: {
        value: (data.userId),
        callback: function($$v) {
          data.userId = $$v
        },
        expression: "data.userId"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "text-danger "
    }, [_vm._v(_vm._s(data.userError))])], 1), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t "), ((index + 1) == _vm.approvelData.length && index !== 0) ? _c('i', {
      staticClass: "fa fa-trash fa-2x",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteRow(data, index)
        }
      }
    }) : _vm._e(), _vm._v("  \n\t\t\t\t\t\t\t\t\t\t"), ((index + 1) == _vm.approvelData.length) ? _c('i', {
      staticClass: "fa fa-plus-circle fa-2x",
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "title": "Add"
      },
      on: {
        "click": function($event) {
          _vm.addNewRow(index)
        }
      }
    }) : _vm._e()])])
  }))])])])]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a51cd8f","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/marketvehicleflm/vehiclerequestapprovalflow/vehiclerequestapprovalflow.component.html
// module id = 1994
// module chunks = 3